import { Action } from 'redux';

import { ResourceGovernanceEditSite, ResourceGovernanceResetSiteToDefaults } from '~src/app/actions/AppActionTypes';
import { isActionFactory } from '~src/app/actions/isActionFactory';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import {  IResourceGovernanceSiteSetting } from '../types/ResourceGovernance';

// For if the action is allowed
export interface IResourceGovernanceEditSiteAction {
  editResourceGovernanceSite: boolean;
}

// The action itself. Which contains if it's allowed.
export const ResourceGovernanceEditSiteAction: IEntityAction<IResourceGovernanceSiteSetting, IResourceGovernanceEditSiteAction> = {
  name: EntityActionNames.ResourceGovernanceEditSiteAction,
  translateName: Messages.resourceGovernanceEditSiteAction,
  isVisible: () => true,
  isClickable: (availableActions: IResourceGovernanceEditSiteAction) => !!(availableActions && availableActions.editResourceGovernanceSite),
  createReduxAction: (targetItems: IResourceGovernanceSiteSetting[]) => editSiteAction(targetItems),
};

export interface ResourceGovernanceEditSiteAction extends Action {
  settings: IResourceGovernanceSiteSetting[];
}

export function editSiteAction(settings: IResourceGovernanceSiteSetting[]): ResourceGovernanceEditSiteAction {
  return {
    type: ResourceGovernanceEditSite,
    settings,
  };
}

export const isEditSiteResourceGovernance = isActionFactory<ResourceGovernanceEditSiteAction>(ResourceGovernanceResetSiteToDefaults);
